export default __webpack_public_path__ + "static/media/logo-Torre-Texao.eb2f7081.png";